var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./smsTwoFactorAuthSetup.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-b4080a9a\",\"hasScoped\":false}!./smsTwoFactorAuthSetup.html"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/components/smsTwoFactorAuthSetup/smsTwoFactorAuthSetup.vue
// module id = 2739
// module chunks = 1